import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import EntityCommentsChat from "@/common/components/Entity/Chat/View/EntityCommentsChat";
import { DamageDetectionDto, EntityType } from "@/core/api/generated/v1";

interface Props {
  damageDetection: DamageDetectionDto;
}

export default function CommentsTabContent({ damageDetection }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock>
        <EntityCommentsChat
          entityId={damageDetection.id!}
          entityType={EntityType.DamageDetection}
          entity={damageDetection}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
